import { render, staticRenderFns } from "./NewDocumentTemplateCategoryDescription.vue?vue&type=template&id=4330048e&"
import script from "./NewDocumentTemplateCategoryDescription.vue?vue&type=script&lang=js&"
export * from "./NewDocumentTemplateCategoryDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports